/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { useContext } from 'react';
import { useTranslation } from '@scuf/localization';
import { ApiContext } from '../../../../context/ApiContext';
import descriptors from '../../../../locales/en-US/descriptors';
import IEnergyManagementProps from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import {
  PortfolioEnergyAllVD,
  PortfolioEnergyElectricityVD,
  PortfolioEnergyGasVD,
  PortfolioEnergyWaterVD
} from './PortfolioEnergyViewDetailsTabs/PortfolioEnergyAllVDTab';
import { renderEneryVDTabs } from '../../../shared/Utils/PortfolioEnergy/PortfolioEnergyVDUtils';

const PortfolioEnergyViewDetailComponent = (props: IEnergyManagementProps) => {
  const { requestContext } = props;
  const d = descriptors.energyManagement;
  const [t] = useTranslation();

  const apiContext = useContext(ApiContext);
  const {
    redirect,
    enableWaterUsageDashboards,
    enableConsumptionSourceSelect
  } = apiContext;
  const onBackarrowClick = () => {
    if (typeof redirect === 'function') {
      redirect('/emaas/portfolio-dashboard');
    }
  };
  const waterTab = [];
  const getParams = new URLSearchParams(location.search);
  const tabName = getParams.get('tabName');

  if (enableWaterUsageDashboards) {
    waterTab.push({
      className: 'emaas-energy-view-details-water',
      title: t(d.WATER),
      component: PortfolioEnergyWaterVD
    });
  }
  const displayTabs = {
    displayTabs: [
      {
        className: 'emaas-energy-view-details-all-utilities',
        title: t(
          enableWaterUsageDashboards ? d.ALLEnergySources : d.ALLUTILITIES
        ),
        component: PortfolioEnergyAllVD
      },
      {
        className: 'emaas-energy-view-details-electricity',
        title: t(d.ELECTRICITY),
        component: PortfolioEnergyElectricityVD
      },
      {
        className: 'emaas-energy-view-details-gas',
        title: t(d.GAS),
        component: PortfolioEnergyGasVD
      },
      // Water Tab at index 3
      ...waterTab
    ],
    requestContext: requestContext,
    ActiveIndex:
      tabName && waterTab.length > 0 && tabName === 'water'
        ? 3
        : apiContext.ActiveIndex,
    enableConsumptionSourceSelect,
    indexDisableEnergyDataSource: waterTab.length > 0 ? [3] : [],
    cemsIntervalEnergySourceOption: apiContext.cemsIntervalEnergySourceOption
  };

  return renderEneryVDTabs(
    props.connectorConfig,
    onBackarrowClick,
    displayTabs,
    enableWaterUsageDashboards
      ? t(d.CONSUMPTIONOVERVIEW)
      : t(d.ENERGYUSAGEOVERVIEW),
    apiContext.energyUsageMultipleCalls
  );
};

export default PortfolioEnergyViewDetailComponent;
